import { render, staticRenderFns } from "./OpenBatchContainer.vue?vue&type=template&id=487ffb97"
import script from "./OpenBatchContainer.vue?vue&type=script&lang=js"
export * from "./OpenBatchContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports